var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c(
        "nav",
        {
          staticClass: "navbar navbar-light",
          staticStyle: { "background-color": "#e3f2fd" }
        },
        [
          _c(
            "router-link",
            { staticClass: "navbar-brand", attrs: { to: "/" } },
            [_vm._v("AQStar")]
          ),
          _vm._v(" "),
          _c(
            "el-dropdown",
            { on: { command: _vm.handleDropDownCommand } },
            [
              _c("span", { staticClass: "el-dropdown-link" }, [
                _vm._v("\n                " + _vm._s(_vm.username)),
                _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "el-dropdown-item",
                    { attrs: { command: "modify_password" } },
                    [_vm._v("修改密码")]
                  ),
                  _vm._v(" "),
                  _c("el-dropdown-item", { attrs: { command: "logout" } }, [
                    _vm._v("注销")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c(
            "el-container",
            [
              _vm.$route.name !== "projectEdit" && _vm.$route.name !== "product"
                ? _c(
                    "el-aside",
                    [
                      _c(
                        "el-menu",
                        {
                          staticClass: "el-menu-vertical-demo",
                          attrs: {
                            "default-openeds": ["1", "2", "3", "4"],
                            "default-active": _vm.$route.path,
                            collapse: _vm.isCollapse,
                            router: ""
                          },
                          on: { open: _vm.handleOpen, close: _vm.handleClose }
                        },
                        [
                          _c(
                            "el-submenu",
                            { attrs: { index: "1" } },
                            [
                              _c("template", { slot: "title" }, [
                                _c("i", { staticClass: "el-icon-user" }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { attrs: { slot: "title" }, slot: "title" },
                                  [_vm._v("用户管理")]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-menu-item",
                                { attrs: { index: "/adminUser" } },
                                [_vm._v("用户列表")]
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "el-submenu",
                            { attrs: { index: "2" } },
                            [
                              _c("template", { slot: "title" }, [
                                _c("i", {
                                  staticClass: "el-icon-data-analysis"
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { attrs: { slot: "title" }, slot: "title" },
                                  [_vm._v("分析")]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-menu-item",
                                { attrs: { index: "/user/regional" } },
                                [_vm._v("用户")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-menu-item",
                                { attrs: { index: "/device/regional" } },
                                [_vm._v("设备")]
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "el-submenu",
                            { attrs: { index: "3" } },
                            [
                              _c("template", { slot: "title" }, [
                                _c("i", { staticClass: "el-icon-date" }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { attrs: { slot: "title" }, slot: "title" },
                                  [_vm._v("日志")]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-menu-item",
                                { attrs: { index: "/httptrace" } },
                                [_vm._v("接口访问日志")]
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.hasPerm("sale_retrieve")
                            ? _c(
                                "el-submenu",
                                { attrs: { index: "4" } },
                                [
                                  _c("template", { slot: "title" }, [
                                    _c("i", {
                                      staticClass: "el-icon-shopping-bag-1"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "title" },
                                        slot: "title"
                                      },
                                      [_vm._v("销售管理")]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-menu-item",
                                    { attrs: { index: "/sale" } },
                                    [_vm._v("销售单")]
                                  ),
                                  _vm._v(" "),
                                  _vm.hasPerm("sale_create")
                                    ? _c(
                                        "el-menu-item",
                                        { attrs: { index: "/sale/add" } },
                                        [_vm._v("新增销售单")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hasPerm("sale_create")
                                    ? _c(
                                        "el-menu-item",
                                        { attrs: { index: "/term" } },
                                        [_vm._v("条款")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hasPerm("sale_create")
                                    ? _c(
                                        "el-menu-item",
                                        { attrs: { index: "/term/add" } },
                                        [_vm._v("新增条款")]
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("el-main", [_c("router-view")], 1)
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改密码",
            visible: _vm.dialogFormVisible,
            width: "35%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "modifyPwdForm",
              attrs: { model: _vm.modifyPwdForm, rules: _vm.modifyPwdRules }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "原密码",
                    "label-width": _vm.formLabelWidth,
                    prop: "oldPwd"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", "show-password": "" },
                    model: {
                      value: _vm.modifyPwdForm.oldPwd,
                      callback: function($$v) {
                        _vm.$set(_vm.modifyPwdForm, "oldPwd", $$v)
                      },
                      expression: "modifyPwdForm.oldPwd"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "新密码",
                    "label-width": _vm.formLabelWidth,
                    prop: "newPwd"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", "show-password": "" },
                    model: {
                      value: _vm.modifyPwdForm.newPwd,
                      callback: function($$v) {
                        _vm.$set(_vm.modifyPwdForm, "newPwd", $$v)
                      },
                      expression: "modifyPwdForm.newPwd"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "新密码确认",
                    "label-width": _vm.formLabelWidth,
                    prop: "newPwdConfirm"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", "show-password": "" },
                    model: {
                      value: _vm.modifyPwdForm.newPwdConfirm,
                      callback: function($$v) {
                        _vm.$set(_vm.modifyPwdForm, "newPwdConfirm", $$v)
                      },
                      expression: "modifyPwdForm.newPwdConfirm"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogFormVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.submitModifyPwdForm("modifyPwdForm")
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fae5bece", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fae5bece","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = null
// module chunks = 